import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import firebase from 'firebase/app';
import 'firebase/analytics'

const firebaseConfig = {
    apiKey: "AIzaSyCnILjRXRxMSzb99sF4Ug_w8dWjaX-DxAY",
    authDomain: "covid-19-ca.firebaseapp.com",
    databaseURL: "https://covid-19-ca.firebaseio.com",
    projectId: "covid-19-ca",
    storageBucket: "covid-19-ca.appspot.com",
    messagingSenderId: "522032990878",
    appId: "1:522032990878:web:fe89591bb6ffa9fa8d498f",
    measurementId: "G-HS6W05F5WP"
};


// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();


ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
